import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Domaine canonique (ex. dojova.com) : redirige les anciens domaines (kaizenfranchise.com) en conservant le chemin. Inactif si non configuré.
const CANONICAL = (process.env.REACT_APP_CANONICAL_HOST || "").trim().toLowerCase();
const host = window.location.hostname.toLowerCase();
if (CANONICAL && host !== CANONICAL && !host.endsWith("emergentagent.com") && host !== "localhost" && !/^\d+\.\d+\.\d+\.\d+$/.test(host)) {
  window.location.replace(`https://${CANONICAL}${window.location.pathname}${window.location.search}${window.location.hash}`);
}

// Après un déploiement, un ancien index.html peut référencer des fichiers JS disparus : on recharge une fois plutôt que d'afficher une page blanche.
window.addEventListener("error", (ev) => {
  const msg = String(ev?.message || ev?.error?.message || "");
  const src = String(ev?.target?.src || "");
  if ((/ChunkLoadError|Loading chunk|Unexpected token '<'/.test(msg) || /\/static\/js\//.test(src)) && !sessionStorage.getItem("dojova_reload_once")) {
    sessionStorage.setItem("dojova_reload_once", String(Date.now()));
    if ("caches" in window) caches.keys().then((k) => Promise.all(k.map((x) => caches.delete(x)))).finally(() => window.location.reload());
    else window.location.reload();
  }
}, true);
window.addEventListener("load", () => setTimeout(() => sessionStorage.removeItem("dojova_reload_once"), 30000));
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => null));
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
